/* eslint-disable fp/no-mutation */
import { v4 as randomUUID } from "uuid";

import { version } from "../package.json";
import type { HighnoteEnvironment } from "../../types";

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const { CARD_VIEWER_IFRAME_PORT = 3003 } = process.env;

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const packageVersion: string = version ?? "";

export const iframeOrigin =
  // eslint-disable-next-line unicorn/consistent-destructuring
  process.env.NODE_ENV === "production"
    ? "https://cdn.highnote.com"
    : `http://localhost:${CARD_VIEWER_IFRAME_PORT}`;

const iframePath = (apiEnvironment: HighnoteEnvironment) => {
  // eslint-disable-next-line fp/no-let
  let path = "";
  // eslint-disable-next-line unicorn/consistent-destructuring
  if (process.env.NODE_ENV === "production") {
    path = `card-viewer/${packageVersion}/`;
  }

  return apiEnvironment === "test"
    ? `${path}index_test.html`
    : `${path}index.html`;
};

export const generateUuid = () => randomUUID();

export const iframeUri = (apiEnvironment: HighnoteEnvironment) =>
  `${iframeOrigin}/${iframePath(apiEnvironment)}`;
